"use client";

import { zodResolver } from "@hookform/resolvers/zod";
import { useForm } from "react-hook-form";
import { z } from "zod";
import { Button } from "@/components/ui/button";
import { Textarea } from "@/components/ui/textarea";
import { Toaster } from "@/components/ui/sonner";
import { toast } from "sonner";
import axios from "axios";

import {
  Form,
  FormControl,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
} from "@/components/ui/form";
import { Input } from "@/components/ui/input";

const formSchema = z.object({
  firstName: z
    .string({
      required_error: "First name is required.",
    })
    .min(2)
    .max(50),
  lastName: z
    .string({
      required_error: "Last name is required.",
    })
    .min(2)
    .max(50),
  email: z
    .string({
      required_error: "An email is required.",
      invalid_type_error: "That isn't a valid email.",
    })
    .email(),
  phone: z.string().min(10).max(14),
  inquiry: z.string().min(20).max(255),
});

export function ContactForm() {
  const form = useForm({
    resolver: zodResolver(formSchema),
    defaultValues: {
      firstName: "",
      lastName: "",
      email: "",
      phone: "",
      inquiry: "",
    },
  });

  function onSubmit(values) {
    console.log(values);
    axios
      .post("https://data.vantagediesel.com/api/inquiry", values)
      .then((response) => {
        if (response.status == 200) {
          toast("Your message was sent successfully.", {
            description: "We will get back to you as soon as we can.",
          });
          form.reset();
        }
      })
      .catch((error) => {
        toast(error.response.message);
      });
  }

  return (
    <div>
      <Form {...form}>
        <form
          onSubmit={form.handleSubmit(onSubmit)}
          className="grid grid-cols-3 md:grid-cols-6 gap-8 "
        >
          <div className="col-span-3">
            <FormField
              control={form.control}
              name="firstName"
              className="col-span-3"
              render={({ field }) => (
                <FormItem>
                  <FormLabel>First Name</FormLabel>
                  <FormControl>
                    <Input placeholder="John" {...field} />
                  </FormControl>
                  <FormMessage />
                </FormItem>
              )}
            />
          </div>
          <div className="col-span-3">
            <FormField
              control={form.control}
              name="lastName"
              render={({ field }) => (
                <FormItem>
                  <FormLabel>Last Name</FormLabel>
                  <FormControl>
                    <Input placeholder="Doe" {...field} />
                  </FormControl>
                  <FormMessage />
                </FormItem>
              )}
            />
          </div>
          <div className="col-span-3">
            <FormField
              control={form.control}
              name="email"
              render={({ field }) => (
                <FormItem>
                  <FormLabel>Email</FormLabel>
                  <FormControl>
                    <Input placeholder="John@example.com" {...field} />
                  </FormControl>
                  <FormMessage />
                </FormItem>
              )}
            />
          </div>
          <div className="col-span-3">
            <FormField
              control={form.control}
              name="phone"
              render={({ field }) => (
                <FormItem>
                  <FormLabel>Phone Number</FormLabel>
                  <FormControl>
                    <Input placeholder="9038877074" {...field} />
                  </FormControl>
                  <FormMessage />
                </FormItem>
              )}
            />
          </div>
          <div className="col-span-6">
            <FormField
              control={form.control}
              name="inquiry"
              render={({ field }) => (
                <FormItem>
                  <FormControl>
                    <Textarea
                      rows="8"
                      className="resize-none"
                      placeholder="What would like to tell us?"
                      {...field}
                    />
                  </FormControl>
                  <FormMessage />
                </FormItem>
              )}
            />
          </div>
          <div className="col-span-1 col-start-3 md:col-start-6 md:ml-auto">
            <Button type="submit">Send</Button>
          </div>
        </form>
      </Form>
      <Toaster />
    </div>
  );
}
